'use client';

import type { CmsApiPagePage } from '#/modules/cms/api/types/CmsApiPage';
import { useReloadIfFreeCodeBlockAndClientNavigation } from '#/modules/cms/hooks/useReloadIfFreeCodeBlockAndClientNavigation';
import { LazyNotFoundPage } from '#/pages/NotFound/LazyNotFoundPage';

import { CmsPagePageBody } from './CmsPagePageBody';
import { CmsPagePageLayout } from './CmsPagePageLayout';

type Props = {
  content: CmsApiPagePage;
};

export function CmsPagePage({ content }: Props) {
  const { showPageNotFound } =
    useReloadIfFreeCodeBlockAndClientNavigation(content);
  if (showPageNotFound) return <LazyNotFoundPage />;

  return (
    <CmsPagePageLayout content={content}>
      <CmsPagePageBody content={content} />
    </CmsPagePageLayout>
  );
}
